import { render, staticRenderFns } from "./PushNotificationsSettings.vue?vue&type=template&id=719b3e6a&scoped=true"
import script from "./PushNotificationsSettings.vue?vue&type=script&lang=js"
export * from "./PushNotificationsSettings.vue?vue&type=script&lang=js"
import style0 from "./PushNotificationsSettings.vue?vue&type=style&index=0&id=719b3e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719b3e6a",
  null
  
)

export default component.exports